import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathMap = {
    '': 'Home',
    'dashboard': 'Dashboard',
    'wallet': 'My Wallet',
    'pages': 'Page Builder',
    'mlm': 'Matrix',
    'network': 'Network Feed',
    'faq': 'FAQ',
    'admin': 'Admin',
    'users': 'Users',
    'nowpayments': 'NOWPayments',
    'products': 'Products',
    'api-keys': 'API Keys'
  };

  const pathSegments = location.pathname.split('/').filter(Boolean);
  
  // Don't show breadcrumbs on public pages or login pages
  if (location.pathname === '/' || location.pathname === '/member/login' || location.pathname === '/member/register') {
    return null;
  }

  const breadcrumbItems = [];
  let currentPath = '';

  pathSegments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const label = pathMap[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
    
    breadcrumbItems.push({
      label,
      path: currentPath,
      isLast: index === pathSegments.length - 1
    });
  });

  // Always include home/dashboard as first item
  const firstPath = breadcrumbItems.length > 0 ? breadcrumbItems[0].path : null;
  const homePath = pathSegments[0] === 'admin' ? '/admin/dashboard' : '/dashboard';
  if (
    breadcrumbItems.length > 0
    && firstPath !== '/dashboard'
    && firstPath !== '/admin/dashboard'
    // Avoid duplicating the last segment (e.g. user is already on /admin/dashboard)
    && !breadcrumbItems.some((b) => b.path === homePath)
  ) {
    breadcrumbItems.unshift({
      label: 'Dashboard',
      path: homePath,
      isLast: false
    });
  }

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2 text-sm">
        {breadcrumbItems.map((item, index) => (
          <li key={`${item.path}-${index}`} className="flex items-center">
            {index > 0 && (
              <ChevronRight className="w-4 h-4 text-gray-400 mx-2" />
            )}
            {item.isLast ? (
              <span className="text-gray-900 font-medium">{item.label}</span>
            ) : (
              <button
                onClick={() => navigate(item.path)}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                {index === 0 && <Home className="w-4 h-4 inline mr-1" />}
                {item.label}
              </button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;